import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { headerMenu_template } from "../components/templates/headerMenu_template";

declare var ko: any;
declare var page: any;

export class header_menu extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;    
    protected headerMenuListTemplate: headerMenu_template;
    protected pagination: pagination_template;

    buildContent(): Array<Element> {
        this.headerMenuListTemplate = new headerMenu_template("headerMenuList", this.viewModel, this)
        return [this.headerMenuListTemplate.build()];

    }

    protected getModuleName(): string {
        return "header_menu";
    }

    fillPage() : void{

        this.getFormData();
    }

    protected getFormData() {

        this.loadingIn(this.headerMenuListTemplate.builtTemplate.children.namedItem("list-results"));

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let url: string = '/api/brand/' + idBrand + "/website_header_menu/get/";
        let params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdl.execute();

    }

    protected onGetFormDataReturn(req, obj) {
        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.headerMenuListTemplate.setMenu(responseParsed, obj.getBrandId());

            });
            obj.loadingOut(obj.headerMenuListTemplate.builtTemplate.children.namedItem("list-results"));
        }

    }

    public viewMenuItems(id: number) : void{
        
        page('/brand/'+ this.getVnAppZone().app.params.idBrand +'/config/header-menu/sub-menu/edit/'+ id);
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }

    public saveMenu(){
        
        if( this.XHRHdl ){
            
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {
            id: this.headerMenuListTemplate.getTemplateViewModel().selectedMenuId(),
            name: this.headerMenuListTemplate.getTemplateViewModel().name(),
            tagTypes: this.headerMenuListTemplate.getTemplateViewModel().tagTypes(),
            contentTypes: this.headerMenuListTemplate.getTemplateViewModel().contentTypes(),
            config: this.headerMenuListTemplate.getTemplateViewModel().selectedConfig(),
        }; 
        ///brand/{idBrand}/website_header_menu/save_menu/
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().getApp().params.idBrand + '/website_header_menu/save_menu/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onGetHeaderMenuSaveReturn;
        this.XHRHdl.execute();
    }

    private onGetHeaderMenuSaveReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                if (response) {
                    //time to redirect
                    window.location.href = "/brand/" + obj.getVnAppZone().getApp().params.idBrand + "/config/header-menu/edit/"+response.id;
                }
            });
        }
    }

    protected addHeaderMenu(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
        
        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/header-menu/add/');
    }

    public redirectToEditPage(data){
        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/header-menu/edit/'+ data.id);
    }
}


// WEBPACK FOOTER //
// ./js/modules/header_menu.ts